import {AppBar, makeStyles, Toolbar} from "@material-ui/core";
import logo from "../logo.png"

const useStyles = makeStyles((theme) => ({
    logo: {
        width: "50%",
        marginLeft: "auto",
        marginRight: "auto",
        maxWidth: 200
    },
    push: {
        flexGrow: 1,
    },
}));

function Header( {right, left, showTitle=true} ) {
    const classes = useStyles();

    return(
        <AppBar position="static">
            <Toolbar>
                {left}
                {showTitle
                ?
                    <img alt={"Music By Vote"} src={logo} className={classes.logo}/>
                : null}
                {right !== undefined
                ? <div className={classes.push} align="right">
                        {right}
                    </div>
                : null}
            </Toolbar>
        </AppBar>
    )
}

export default Header